<template>
  <loading :active="isLoading" :can-cancel="false" :color="'#bfd243'" :height="100" :width="350" :is-full-page="true">
  </loading>
  <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="bg-white p-5 shadow-lg">
      <div class="flex">
        <h2 class="text-lg leading-6 font-medium text-cool-gray-900 w-full sm:w-1/4 mt-2">
          Personal
        </h2>
      </div>
      <div class="block sm:flex mt-5 sm:space-x-4 space-y-6 sm:space-y-0">
        <div class="w-full">
          <input
            v-model="searchValue"
            type="text"
            class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
            placeholder="Buscar..."
            id="input_searsh"
            @keyup="searchUser()"
          />
        </div>
        <div class="w-full">
          <select
            name="select-filter-user"
            id="select-filter-user"
            class="form-select py-3 px-4 block w-full transition ease-in-out duration-150"
            v-model="filterSelect"
          >
            <option value="0">Tipo de filtro</option>
            <option value="1">Nombre</option>
            <option value="2">Correo</option>
            <!-- <option value="3">Fecha ingreso</option> -->
          </select>
        </div>
        <div class="w-full">
          <button
            class="bg-white px-5 py-2 rounded-xl hover:bg-orange-700 w-full sm:w-2/3 transition duration-150 flex border-2 hover:border-orange-700 hover:text-white sm:float-right active:bg-orange-700 shadow-md focus:outline-none focus:shadow-outline-orange focus:border-orange-700"
            v-on:click="OpenModal()"
            id="btn-regiter-user"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              />
            </svg>
            <label class="ml-2">Usuario</label>
          </button>
        </div>
      </div>
    </div>

    <div class="w-full py-10 px-2 sm:px-0">
      <!-- contenido de la tarjeta -->
      <div v-for="datauser in listaDePersonalSeleccionado" :key="datauser">
        <CardsUsers 
          :userObj="datauser"
          ref="CardsUsers"  
          v-on:reload_info_user="getPersonalByFilter(20, 1)"  />
      </div>
      <!-- contenido de la tarjeta -->
    </div>

    <div class="bg-white p-5 shadow-lg">
      <div class="flex">
        <div class="m-auto flex">
          <div
            v-if="pageActu != 1"
            class="h-10 w-10 bg-orange-700 text-white hover:bg-orange-500 rounded-l-lg items-center justify-center flex pagination-items"
            @click="selectPagination(1)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
              />
            </svg>
          </div>
          
            <div class="h-10 w-10 bg-orange-700 text-white hover:bg-orange-500 items-center justify-center flex pagination-items"
            style="cursor: pointer"
            v-for="page in pagesOfRow"
            :key="page"
            @click="selectPagination(page)"
            >
              {{ page }}
            </div>
          
          <div
            v-if="pageActu < (total_rows/20)"
            class="h-10 w-10 bg-orange-700 text-white hover:bg-orange-500 items-center justify-center flex rounded-r-lg pagination-items"
            @click="selectPagination(parseInt(total_rows/20)+1)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 5l7 7-7 7M5 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- modal de agregar usuario -->
    <modal-add-user ref="ModalAddUser" v-on:reload_data_user="getPersonalByFilter(20, 1)" />
    <!-- modal de agregar usuario -->
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import { onMounted, ref } from "vue";
import CardsUsers from "@/components/dashboard/personal/CardsUsers.vue";
import ModalAddUser from "@/components/dashboard/personal/ModalAddUser.vue";
import { getUserAuth } from "@/helpers/auth.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { onBeforeRouteUpdate } from "vue-router";

export default {
  components: {
    CardsUsers,
    ModalAddUser,
    Loading,
  },
  setup() {

    const multicrapi = process.env.VUE_APP_MULTICR;
    let listaTotal = ref([]);
    let listaFiltrada = ref([]);
    let listaDePersonalSeleccionado = ref([]);
    const isLoading = ref(false);

    let listaDePersonal = ref ([]);
    let filterSelect = ref(0);
    let searchValue = ref("");
    let pagesOfRow = ref([1]);
    let pageActu = ref(0);
    let filtro = ref("");
    let total_rows = ref("");
    let responsivePagination = ref({
      items: 10,
    });

    onBeforeRouteUpdate(async () => {
      isLoading.value = true;
      await getPersonalByFilter(20, 1);
      isLoading.value = false;
    });

    onMounted(async () => {
      $(window).resize(function () {
        if (window.screen.width >= 100 && window.screen.width <= 352)
          responsivePagination.value.items = 1;
        if (window.screen.width >= 352 && window.screen.width <= 428)
          responsivePagination.value.items = 2;
        if (window.screen.width >= 428 && window.screen.width <= 584)
          responsivePagination.value.items = 5;
        if (window.screen.width >= 600) responsivePagination.value.items = 10;
      });
       try {
        isLoading.value = true;
        filtro.value = 20;
        await getPersonalByFilter(filtro.value, 1);
        document.getElementById("input_searsh").value = "";
      } catch (error) {
      console.error(error);
      } finally {
        isLoading.value = false;
      }
    });
    
    function searchUser() {

      listaFiltrada.value = listaTotal.value.filter((item) => {
        if (filterSelect.value === "1") {
          return item.persona.nombres
            .toUpperCase()
            .includes(searchValue.value.toUpperCase());
        }

        if (filterSelect.value === "2") {
          return item.email
            .toUpperCase()
            .includes(searchValue.value.toUpperCase());
        }

        return true;
      });

      total_rows.value = listaFiltrada.value.length;
      pageActu.value = 1;
      paginate(1);
      buildPages();
    }

    async function getPersonalByFilter(filter, selected_page) {
      try {
        const res = await axios.get(
          multicrapi +
            "/empleados/ordenar_personal_por_filtro?token_auth=" +
            getUserAuth() +
            "&filtro=" +
            filter
        );

        if (res.status === 200) {
          listaTotal.value = res.data.respuesta.lista_ordenada.flat();
          listaFiltrada.value = [...listaTotal.value];

          total_rows.value = listaFiltrada.value.length;
          pageActu.value = selected_page;

          paginate(selected_page);
          buildPages();
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    function paginate(page) {
      const start = (page - 1) * filtro.value;
      const end = start + filtro.value;

      listaDePersonalSeleccionado.value =
        listaFiltrada.value.slice(start, end);
    }

    function getTotalPersonal() {
      axios.get(
        multicrapi + "/empleados/consultar_personal?token_auth=" +
        getUserAuth()
      )
      .then((res) => {
        if (res.status == 200) {
          listaTotal.value = res.data.respuesta.informacion;
        }
      });
    }

    function selectPagination(page){
      pageActu.value = page;
      paginate(page);
    }

    function OpenModal() {
      $("#show-modal-active-user").addClass("show-modal-active");
    }

    function buildPages() {
      pagesOfRow.value = [];
      const totalPages = Math.ceil(total_rows.value / filtro.value);

      for (let i = 1; i <= totalPages; i++) {
        pagesOfRow.value.push(i);
      }
    }

    return {
      getPersonalByFilter,
      getTotalPersonal,
      selectPagination,
      OpenModal,
      listaDePersonal,
      listaDePersonalSeleccionado,
      searchUser,
      filterSelect,
      listaTotal,
      searchValue,
      pagesOfRow,
      pageActu,
      filtro,
      total_rows,
      responsivePagination,
      isLoading
    };
  },
};
</script>

<style>
.toggle-checkbox:checked {
  @apply: right-0 border-green-400;
  right: 0;
  border-color: #68d391;
}
.toggle-checkbox:checked + .toggle-label {
  @apply: bg-green-400;
  background-color: #68d391;
}
button:focus {
  outline: none;
}
@media (max-width: 300px) {
  .pagination-items {
    height: 20px;
    width: 30px;
  }
}
/* :focus {
  outline: none;
} */
</style>